import axiosInstance from "@/utils/axiosInstance";
import store from "@/store";

const baseUrl = `api/mission-orders`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  create({commit}, payload: {
    clientCompanyId: number,
    serviceCompanyId: number,
    buildingId: number,
    type: string,
    countAccessLeft: number,
    startDate: Date,
    endDate: Date | null,
    keyGroupId: number | null,
    keyId: number | null,
    nonTransferableId: number | null,
  }) {
    return axiosInstance.post(`${baseUrl}`, {
      clientCompanyId: payload.clientCompanyId,
      serviceCompanyId: payload.serviceCompanyId,
      buildingId: payload.buildingId,
      type: payload.type,
      countAccessLeft: payload.countAccessLeft,
      startDate: payload.startDate,
      endDate: payload.endDate,
      keyGroupId: payload.keyGroupId,
      keyId: payload.keyId,
      nonTransferableId: payload.nonTransferableId,
    }).then((data) => data.data);
  },
  update({commit}, payload: {
    id: number,
    clientCompanyId: number,
    serviceCompanyId: number,
    buildingId: number,
    type: string,
    countAccessLeft: number,
    startDate: Date | null,
    endDate: Date,
  }) {
    return axiosInstance.put(`${baseUrl}/${payload.id}`, {
      clientCompanyId: payload.clientCompanyId,
      serviceCompanyId: payload.serviceCompanyId,
      buildingId: payload.buildingId,
      type: payload.type,
      countAccessLeft: payload.countAccessLeft,
      startDate: payload.startDate,
      endDate: payload.endDate,
    }).then((data) => data.data);
  },
  assign({commit}, payload: { id: number, userGroupId: number | null}) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/assign`, {
      userGroupId: payload.userGroupId,
    }).then((data) => data.data);
  },
  delegate({commit}, payload: { id: number, delegatedCompanyId: number | null}) {
    return axiosInstance.post(`${baseUrl}/${payload.id}/delegate`, {
      delegatedCompanyId: payload.delegatedCompanyId,
    }).then((data) => data.data);
  },
  readById({commit}, payload: { id: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
  read({commit}, payload: {
    page: number,
    itemsPerPage: number,
    search: string | null,
    envCompanyId: number | null,
    clientCompanyId: number | null,
    serviceCompanyId: number | null,
    buildingId: number | null,
    keyGroupId: number | null,
  }) {
    return axiosInstance.get(`${baseUrl}`, {
      params: {
        page: payload.page,
        itemsPerPage: payload.itemsPerPage,
        search: payload.search,
        envCompanyId: payload.envCompanyId,
        clientCompanyId: payload.clientCompanyId,
        serviceCompanyId: payload.serviceCompanyId,
        buildingId: payload.buildingId,
        keyGroupId: payload.keyGroupId,
      },
    }).then((data) => data.data);
  },
  delete({commit}, payload: {id: number}) {
    return axiosInstance.delete(`${baseUrl}/${payload.id}`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
